import { t } from 'i18next';
import PopUpBasic from '../../components/popup/PopUpBasic';

interface ConfirmToCompleteTradingPopupProps {
  handleClosePopup: () => void;
  handleNavigateToReviewPage: () => void;
  category: 'TradingPhotoCard' | 'MatchedTradingPhotoCard';
}

const ConfirmToCompleteTradingPopup = ({
  handleClosePopup,
  handleNavigateToReviewPage,
  category
}: ConfirmToCompleteTradingPopupProps) => {
  return (
    <div className="fixed top-0 left-0 w-full h-full bg-black/50 z-[999] flex items-center justify-center">
      <PopUpBasic
        type="short"
        title={
          category === 'TradingPhotoCard'
            ? t('tradingPhotoCardChatRoom.completedSalePopupTitle')
            : t('tradingPhotoCardChatRoom.completedExchangeTitle')
        }
        description={
          <p className="text-center leading-tight">
            {t('tradingPhotoCardChatRoom.completedPopupDescription')}
          </p>
        }
        primaryButtonText={t('cancel')}
        secondaryButtonText={
          category === 'TradingPhotoCard'
            ? t('tradingPhotoCardChatRoom.completedTradingMenu')
            : t('tradingPhotoCardChatRoom.completedExchangingMenu')
        }
        onPrimaryButtonClick={handleClosePopup}
        onSecondaryButtonClick={handleNavigateToReviewPage}
        className="mx-auto w-[311px]"
      />
    </div>
  );
};

export default ConfirmToCompleteTradingPopup;
